import { render, staticRenderFns } from "./course-detail.vue?vue&type=template&id=79af61e1&scoped=true&"
import script from "./course-detail.vue?vue&type=script&lang=js&"
export * from "./course-detail.vue?vue&type=script&lang=js&"
import style0 from "./course-detail.vue?vue&type=style&index=0&id=79af61e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af61e1",
  null
  
)

export default component.exports